export enum CallSourceEnum {
  INBOUND = 1,
  OUTBOUND = 2,
  QUEUE = 3,
  CALLBACK = 4,
  INSTA_CALLING = 5
}
export type callSource = {
  [key in CallSourceEnum]: string;
};

export const CALL_SOURCE_ENUM_LIST: callSource = {
  [CallSourceEnum.INBOUND]: 'Call Inbound',
  [CallSourceEnum.OUTBOUND]: 'Call Outbound',
  [CallSourceEnum.QUEUE]: 'Call Queue',
  [CallSourceEnum.CALLBACK]: 'Call Back',
  [CallSourceEnum.INSTA_CALLING]: 'Insta Calling'
};
